import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './checkbox-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class CheckboxFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: any;
  private editing: boolean = false;

  public value: any;
  public options: { id: string; value: string }[] = [
    { id: 'true', value: 'Yes' },
    { id: 'false', value: 'No' },
    { id: 'null', value: 'Not Set' },
  ];

  get displayValue(): string {
    return 'REDACTED';
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.initializeInput();
  }

  initializeInput(): void {
    this.value = String(this.model[this.fieldDef.name]);

    if (this.value !== 'null') {
      let booleanValue = new Boolean(this.value);

      if (booleanValue === true || booleanValue === false) {
        this.value = JSON.parse(this.value.toString());
        this._originalValue = this.value;
      }
    }

    this._originalValue = this.value;
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
    }
  }

  onSelectionChange(): void {
    this.onSave();
    this.editing = false;
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: JSON.parse(this.value) });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.initializeInput();
  }
}
